import Tab from "components/Tab";
import DjangoContextMiddleware from "../../../../contents/docs/libraries/python/_snippets/django-context-middleware.mdx";
import PythonFlaskExceptionAutocapture from "../../../../contents/docs/libraries/python/_snippets/python-flask-exception-autocapture.mdx";
import PythonFastAPIExceptionAutocapture from "../../../../contents/docs/libraries/python/_snippets/python-fastapi-exception-autocapture.mdx";
import StepVerifyErrorTracking from "../../../../contents/docs/error-tracking/installation/_snippets/step-verify-error-tracking.mdx";
import StepUploadSymbolSets from "../../../../contents/docs/error-tracking/installation/_snippets/step-upload-symbol-sets.tsx";
import * as React from 'react';
export default {
  Tab,
  DjangoContextMiddleware,
  PythonFlaskExceptionAutocapture,
  PythonFastAPIExceptionAutocapture,
  StepVerifyErrorTracking,
  StepUploadSymbolSets,
  React
};